import { Step } from "react-joyride";

export const tourStepsBadgesAchievements = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Badges and achievements mark practice goals, such as finishing a fast letter session. Gray items are not earned yet.",
      disableBeacon: true,
    },
    {
      target: ".badges-section",
      content:
        "Badges are smaller goals. They light up after you earn them during practice.",
    },
    {
      target: ".achievements-section",
      content:
        "Achievements are bigger milestones. Keep practicing collections to unlock them.",
    },
    {
      target: ".completion-counts-section",
      content:
        "This list shows how many times you have finished each collection. Reports has more detail per session.",
    },
  ];

  return steps;
};
